<template>
  <div>

    <body data-anchor="pagetop" class="home page-template-default page page-id-314 wp-embed-responsive st-Grid_Container" style="overflow-y: unset;">
      <navbar follow="st-Header" imgSrc="../../../../static/img/logo/logo-black.png"></navbar>
      <div class="st-FixedPoint"></div>
      <div class="st-MainContainer">
        <main class="st-MainContents mt-6">
          <div class="st-Grid">
            <div class="st-Grid_Inner">
              <article class="news-Detail pt-0">
                <header class="news-Detail_Title common-text-appear news-detail-appear-1" data-appear="true">
                  <div class="sw-Eyebrow">
                    <p class="sw-Eyebrow_Lavel" id="lavel" data-lavel="product">
                      <font>
                        <font id="lavel-name">会社情報</font>
                      </font>
                    </p>
                    <p class="sw-Eyebrow_Date">
                      <font>
                        <font id="news-date">2020.10.30</font>
                      </font>
                    </p>
                  </div>
                  <h1>
                    <font>
                      <font id="news-title">标题内容标题内容标题内容</font>
                    </font>
                  </h1>
                </header>
                <div class="news-Detail_Body">
                  <div class="common-image-appear news-detail-appear-2" data-appear="true">
                    <picture><img id="news-imgSrc" width="100%" /></picture>
                  </div>
                  <div class="common-image-appear news-detail-appear-22 pt-4 d-none" data-appear="true">
                    <picture><img id="news-imgSrc2" width="100%" /></picture>
                  </div>
                  <div class="common-image-appear news-detail-appear-23 pt-4 d-none" data-appear="true">
                    <picture><img id="news-imgSrc3" width="100%" /></picture>
                  </div>
                  <div class="common-image-appear news-detail-appear-24 pt-4 d-none" data-appear="true">
                    <picture>
                    <div class="row col-12 m-0">
                      <div class="col-6 pl-0">
                        <img id="news-imgSrc1" width="100%" />
                      </div>
                      <div class="col-6 pr-0">
                      <img id="news-imgSrc4" width="100%" />
                      </div>
                    </div>
                  </picture>
                  </div>
                  
                  <div class="common-text-appear news-detail-appear-3" data-appear="true">
                    <font></font><br>
                    <font>
                      <font id="news-content">
                      </font>
                    </font>
                  </div>
                </div>

              </article>
            </div>
          </div>
          <section class="top-card pt-0 pb-5" style="background-color: #fff;">
            <div class="st-Grid_Inner news-detail-appear-4 p-0 pl-md-5" data-appear="true">
              <h2 class="sw-Section_Header news-detail-appear-5" data-appear="true">
                <span class="sw-Section_Header-en"><b>
                    <font>
                      <font>OTHER NEWS</font>
                    </font>
                  </b></span>
                <span class="sw-Section_Header-ja"><b>
                    <font>
                      <font>お知らせ</font>
                    </font>
                  </b></span>
              </h2>
              <div class="st-News_Slide swiper-container-news-detail swiper-container-initialized swiper-container-horizontal news-detail-appear-6" data-appear="true">
                <div class="swiper-wrapper">
                  <div v-for="(item, index) in newsList" :key="index" class="swiper-slide swiper-slide-news">
                    <a @click="goNewsDetail(item.newsId)">
                      <div class="st-News_Slide-image">
                        <div class="st-News_Slide-image-inner">
                          <div :style="{'background-image':`url(../../../static/img/news/${item.imgSrc})`}"></div>
                        </div>
                      </div>
                      <div class="sw-Eyebrow">
                        <p class="sw-Eyebrow_Lavel" :data-lavel="item.lavel">
                          <font>
                            <font>{{item.lavel==='company'? 'COMPANY':'PRODUCT'}}</font>
                          </font>
                        </p>
                        <p class="sw-Eyebrow_Category">
                          <font>
                            <font></font>
                          </font>
                        </p>
                        <p class="sw-Eyebrow_Date">
                          <font>
                            <font>{{item.date}}</font>
                          </font>
                        </p>
                      </div>
                      <p class="st-News_Slide-title">
                        <font>
                          <font>{{item.title}}</font>
                        </font>
                      </p>
                    </a>
                  </div>

                </div>
                <div class="swiper-button-next"><i class="icf el-icon-arrow-right" style="font-size:25px;bottom: 15px;"></i></div>
                <div class="swiper-button-prev swiper-button-disabled"><i class="icf el-icon-arrow-left" style="font-size:25px;bottom: 15px;"></i></div>
                <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
              </div>
            </div>
          </section>
          <div class="st-Breadcrumbs">
            <ul class="st-BreadcrumbsList pl-0">
              <li class="st-BreadcrumbsList_Item">
                <router-link class="st-BreadcrumbsList_Item-link" to="/">
                  <span itemprop="name">
                    <font>
                      <font>ホーム</font>
                    </font>
                  </span>
                </router-link>
              </li>
              <li class="st-BreadcrumbsList_Item">
                <p itemprop="item" aria-current="page" style="margin-bottom: 0rem;"><span itemprop="name">
                    <font>
                      <font>お知らせ</font>
                    </font>
                  </span></p>
              </li>
            </ul>
          </div>
        </main>
      </div>
      <copyright></copyright>
    </body>
  </div>
</template>
<style />
<script type="text/javascript">
import copyright from './../copyright'
import navbar from './../navbar'
import Swiper from 'swiper/swiper-bundle.js'
import 'swiper/swiper-bundle.css'
import newsList from '../../../../static/js/news-list.js'

export default {
  inject: ["reload"],
  components: { copyright, navbar },
  data: function () {
    return {
      mySwiperNews: '',
      newsList: newsList,
      hasManyNewsimg: false
    }
  },
  mounted() {
    let news = null
    if (this.newsList) {
      this.newsList.forEach((e) => {
        if (e.newsId == this.$route.query.newsId) {
          news = e
        }
      })
    }

    if (news) {
      $("#lavel").attr("data-lavel", news.lavel)
      $("#lavel-name").text(news.lavel == 'company' ? '会社情報' : '製品情報');
      $("#news-date").text(news.date);
      $("#news-title").text(news.title);
      $("#news-content").text(news.content);
      $("#news-imgSrc").attr("src", `../../../static/img/news/${news.imgSrc}`);
      if(news.imgSrc1){
        $("#news-imgSrc1").attr("src", `../../../static/img/news/${news.imgSrc1}`);
        $(".news-detail-appear-21").removeClass("d-none")
        this.hasManyNewsimg = true
      }
      if(news.imgSrc2){
        $("#news-imgSrc2").attr("src", `../../../static/img/news/${news.imgSrc2}`);
        $(".news-detail-appear-2").removeClass("d-none")
        $(".news-detail-appear-22").removeClass("d-none")
      }
      if(news.imgSrc3){
        $("#news-imgSrc3").attr("src", `../../../static/img/news/${news.imgSrc3}`);
        $(".news-detail-appear-23").removeClass("d-none")
      }
      if(news.imgSrc4){
        $("#news-imgSrc4").attr("src", `../../../static/img/news/${news.imgSrc4}`);
        $(".news-detail-appear-24").removeClass("d-none")
      }
    }
    this.init()
  },
  methods: {
    goNewsDetail(newsId) {
      this.reload();
      this.$router.push({
        path: '/news/news-detail',
        query: { newsId: newsId }
      }).catch(err => { window.scrollTo(0, 0); })
    },
    init() {
      $('.news-detail-appear-1').addClass('appear')
      $('.news-detail-appear-2').addClass('appear')
      $('.news-detail-appear-3').addClass('appear')
      $(".news-detail-appear-4").addClass('st-Grid_Inner_appear')
      $('.news-detail-appear-5').addClass('appear')
      $('.news-detail-appear-6').addClass('appear')
      $('.news-detail-appear-21').addClass('appear')
      $('.news-detail-appear-22').addClass('appear')
      $('.news-detail-appear-23').addClass('appear')
      $('.news-detail-appear-24').addClass('appear')

      let mySwiperNewsSettings = {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 0
          },
          769: {
            slidesPerView: 4,
            spaceBetween: 50
          },
        }
      }

      this.mySwiperNews = new Swiper('.swiper-container-news-detail', mySwiperNewsSettings)
      window.onresize = () => {
        let viewW = $(window).width()
        if (viewW < 1200) {
          this.mySwiperNews.params.slidesPerView = 1
        } else {
          this.mySwiperNews.params.slidesPerView = 3
        }
        // this.mySwiperNews = new Swiper('.swiper-container-news', mySwiperNewsSettings)
      }

      // element.offsetHeight
      $(document).scroll(() => {
        let scroH = $(document).scrollTop()
        let viewW = $(window).width()
        if (scroH > 50) {
          $('.st-Header').addClass('is-follow')
          $('.st-Footer_Pagetop').addClass('is-follow')
        } else {
          $('.st-Header').removeClass('is-follow')
          $('.st-Footer_Pagetop').removeClass('is-follow')
        }
        if (viewW > 769) {

          if (scroH > 320) {
            $('.news-detail-appear-1').removeClass('appear')
          } else {
            $('.news-detail-appear-1').addClass('appear')
          }

          if (scroH > 820 && !this.hasManyNewsimg) {
            $('.news-detail-appear-2').removeClass('appear')
          } else {
            $('.news-detail-appear-2').addClass('appear')
          }

          if (scroH > 0) {
            $('.news-detail-appear-6').addClass('appear')
          } else {
            $('.news-detail-appear-6').removeClass('appear')
          }

        } else {
          $('.news-detail-appear-1').addClass('appear')
          $('.news-detail-appear-2').addClass('appear')
          $('.news-detail-appear-3').addClass('appear')
          $(".news-detail-appear-4").addClass('st-Grid_Inner_appear')
          $('.news-detail-appear-5').addClass('appear')
          $('.news-detail-appear-6').addClass('appear')
        }
      })
    }
  }
}
</script>
<style scoped src="../../../../static/css/news.css">
</style>



// WEBPACK FOOTER //
// src/components/pages/news/news-detail.vue